import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface AdminRouteProps {
  children: JSX.Element;
}

function AdminRoute({ children }: AdminRouteProps): JSX.Element {
  const { isFullAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!isFullAdmin) {
    return <Navigate to="/dashboard-capacitaciones" replace />;
  }

  return children;
}

export default AdminRoute;